import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  max-width: 900px;
  margin: 0 auto;
`;
